import axios from "axios";

const instance = axios.create({
  baseURL: process.env.VUE_APP_AXIOS_ENDPOINT,
  withCredentials: true,
});

export default instance;
